import React, { useEffect } from 'react'
import logo from '../assets/images/office-free-header-logo.svg'
import image from '../assets/images/office-free-header-logo.svg'
import './NotEnoughSize.scss'
import useWindowDimensions from '../utils/useWindowDimensions'
import { useHistory } from 'react-router-dom'

const NotEnoughSize = () => {
  return (
    <div className="warning-container">
      <h4>Bilgisayar özellikleri Koç Office Free için yeterli değil</h4>
      <p>
        Daha yüksek ekran çözünürlüğünü destekleyen bir cihaz kullanarak Koç Office Free'ye giriş yapabilirsin. En az
        1024 piksel genişliğinde bir ekrana ihtiyacın var.
      </p>
      <img src={image} width="400px" className="illustration" />
    </div>
  )
}

export default NotEnoughSize
